module.exports = __webpack_public_path__ + "assets/images/history_uz.jpg";